import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { useStyles } from './style';

interface Props {
  text?: string;
}

const NoData: React.FC<Props> = ({ text = 'NoInformation' }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <InfoOutlinedIcon className={classes.icon} />
      <span>{t(text)}</span>
    </div>
  );
};

export default memo(NoData);
